/* eslint-disable import/no-cycle */
import CouponDTO from '../types/Coupon';
import { ReferralDTO } from '../types/Referral';
import EventDTO, { EventAudienceDiscountDTO } from './event';
import { EventSeatDTO } from './event-seat';
import { EventTransactionSummaryDTO } from './event-transaction';
import { PaymentDTO } from './payment';
import TicketDTO from './ticket';
import { UserBusiness, UserEvent } from './user';

export enum PendingOrderStatus {
  no_reminder = 'no_reminder',
  purchased_without_reminder = 'purchased_without_reminder',
  first_reminder = 'first_reminder',
  second_reminder = 'second_reminder',
  third_reminder = 'third_reminder',
  purchased_after_first = 'purchased_after_first',
  purchased_after_second = 'purchased_after_second',
  purchased_after_third = 'purchased_after_third',
  did_not_purchase = 'did_not_purchase',
}

export interface ItemDTO {
  id: string;
  name: string;
  last_name: string;
  person_id: string;
  ticket: TicketDTO;
  event_seat?: EventSeatDTO;
  audience_discount?: EventAudienceDiscountDTO;
  audience_discount_id?: string;
  used_at: string | null;
}

export interface OrderDTO {
  id: string;
  user_id?: number;
  event_id: string;
  status: 'paid' | 'pending' | 'rejected',
  email: string;
  instagram_user?: string;
  items: ItemDTO[];
  is_manual: boolean;
  payments: PaymentDTO[];
  event: EventDTO;
  display_id: string;
  custom_id: string;
  created_at: string;
  coupon_id: string;
  coupon: CouponDTO;
  owner_referral: ReferralDTO | null;
  pending_status: PendingOrderStatus;
}

export interface OrderItemData {
  name: string;
  last_name: string;
  person_id: string;
  ticket_id: string;
  ticket: TicketDTO;
  ticket_extra: boolean;
  seat_name?: string;
  seat_id?: string;
  audience_discount?: EventAudienceDiscountDTO;
  audience_discount_id?: string;
}

export interface TicketSummaryDTO {
  ticket_name: string;
  ticket_id: string;
  ticket_price: number;
  count: number;
  total: number;
  count_manual: number;
  count_online: number;
  total_manual: number;
  total_online: number;
  scanned: number;
}

export interface SellerSummaryDTO {
  seller_id: string;
  seller_name: string;
  tickets_summary: TicketSummaryDTO[];
  manual_items_count: number;
  manual_amount: number;
  manual_comission_amount: number;
  referral_count: number;
  referral_amount: number;
  referral_comission_amount: number;
  total_items_count: number;
  total_amount: number;
  total_comission_amount: number;
  service_charge_total: number;
  discounts_total: number;
  tickets_total: number;
  seller_orders: OrderDTO[];
  transactions_summary: EventTransactionSummaryDTO;
  balance: number;
  referral: ReferralDTO | null;
  items_scanned: number;
  seller_qr_count: number;
  user: {
    current_event: UserEvent;
    current_business: UserBusiness;
    email: string;
  };
}

export type SellerSimpleSummaryDTO = {
  user_id: string;
  user_event_id: string | null;
  username: string;
  email: string;
  active: boolean;
  permissions: string;
  alias: string | null;
  tag: string | null;
  group: string | null;
  total_items_count: number;
  items_scanned: number;
  total_amount_online: number;
  total_amount_referral: number;
  total_amount: number;
  commission: number;
  total_commision: number;
  expenses: number;
  balance: number;
};

export interface OrderTotalsDTO {
  total_amount: number;
  subtotal: number;
  tickets_total: number;
  discounts_total: number;
  service_charge_fee: number;
  payment_method_discounts: number;
  base_tickets_total: number;
}
